/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:14 PM
 *
 */

import { Bars } from 'react-loader-spinner';

const Loader = () => {
  return (
    <div className="flex h-[55vh] items-center justify-center">
      <Bars color="green" />
    </div>
  );
};

export default Loader;
